import React, { useState } from "react";
import {
    Box,
    Grid,
    Button,
    Collapse,
    Grow,
    Dialog,
    Tooltip,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    FormControl,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Typography,
} from "@mui/material";
import { FcInfo } from "react-icons/fc";
import { KeyboardArrowDown, KeyboardArrowUp, CloudUpload, CloudDownload } from "@mui/icons-material";
import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import TableButtons from "../Button/TableButtons";
import LoadingBackdrop from "../LoadingBackdrop/LoadingBackdrop";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CheckItemPopup from "../Popup/CheckItemPopup";
import { StyledTableDiv } from "../StyledComponents/StyledComponents";
import StartDate from "../StartDate/StartDate";
import EndDate from "../EndDate/EndDate";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import DocumentPopup from "../../components/Popup/DocumentPopup";

export default function CheckItemGroup(props) {
    const { t } = useTranslation("translation");

    const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment(new Date()).add(1, "days").format("YYYY-MM-DD"));

    const [pickDate, setpickDate] = useState(false);
    const [pickEndDate, setpickEndDate] = useState(false);
    const [errorStateName, setErrorStateName] = useState(false);
    const [errorTextName, setErrorTextName] = useState("");
    const [addButtonDisabled, setAddButtonDisabled] = useState(false);

    const onStartDateChangeHandler = (date) => {
        setStartDate(date);
        props.onStartDateChangeHandler(date);
    };

    const onEndDateChangeHandler = (date) => {
        setEndDate(date);
        props.onEndDateChangeHandler(date);
    };

    const updateAddHandlerCIG = (row) => {
        setpickDate(false);
        setpickEndDate(false);
        if (row.id !== "") {
            setStartDate(row.validityStartDate);
            setEndDate(row.validityEndDate);
            props.updateAddHandlerCIG(row);
        } else {
            setDisableButton(false);
            props.updateAddHandlerCIG(row);
        }
        setEditable(false);
        setEditableCI(false);
    };

    const [deleteCheckItem, setDeletedCheckItem] = useState(false);
    const deleteHandlerCheckItem = (row) => {
        setDeletedRow(row);
        toggleModal();
        setDisableButton(false);
    };

    const deleteHandler = (row) => {
        toggleModal();
        if (!deleteCheckItem) {
            props.deleteCIGHandler(row);
        } else {
            props.deleteCIHandler(row);
            setOpenRow(!openRow);
        }
    };

    const addBlankRowHandler = () => {
        setAddButtonDisabled(true);
        setErrorStateName(true);
        setErrorTextName(t("EmptyCheck"));
        setPage(0);
        setpickDate(true);
        setpickEndDate(true);
        setDisableButton(true);
        let addedBlankRow = [];
        addedBlankRow = [
            {
                id: "",
                name: "",
                note: "",
            },
        ];
        props.setRowsFunction(addedBlankRow.concat(props.rows));
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);

        setEditableRowCI(addedBlankRow[0].id);
        setEditableCI(true);
    };

    //filter table
    const filterData = (e) => {
        let filterText = e.target.value.toLowerCase();
        console.log(props.initialRows);
        let filteredItems = props.initialRows.filter((item) => item.name.toLowerCase().includes(filterText) || item.note.toLowerCase().includes(filterText));
        props.setRowsFunction(filteredItems);
        setEditable(false);
        setEditableCI(false);
        setOpenRow(false);
        setDisableButton(false);
    };

    //pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //edit rows
    const [editable, setEditable] = useState(false);
    const [editableCI, setEditableCI] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    const [editableRowCI, setEditableRowCI] = useState("");
    const enableEditHandler = (row) => {
        if (disableButton) {
            props.setRowsFunction(cloneObject(props.initialRows));
        }
        props.enableEditHandler(row);
        setStartDate(row.validityStartDate);
        setEndDate(row.validityEndDate);
        setpickDate(true);
        setpickEndDate(true);
        setEditableRow(row.id);
        setEditable(true);

        setEditableRowCI(row.id);
        setEditableCI(true);

        setErrorStateName(false);
        setErrorTextName("");
        setAddButtonDisabled(false);
    };

    const disableEditHandler = () => {
        const oldRows = cloneObject(props.initialRows);
        props.setRowsFunction(oldRows);
        setEditable(false);
        setEditableCI(false);
        setOpenRow(false);
        setDisableButton(false);
    };

    const NameHandler = (event) => {
        const error = event.target.value.length == 0 ? true : false;
        const errorText = event.target.value.length == 0 ? t("EmptyCheck") : "";
        setErrorStateName(error);
        setErrorTextName(errorText);
        setAddButtonDisabled(error);
        props.NameHandler(event.target.value);
    };

    const NoteHandler = (event) => {
        props.NoteHandler(event.target.value);
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        setDeletedCheckItem(false);
        setOpenRow(!openRow);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //enable disable add button
    const [disableButton, setDisableButton] = useState(false);

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        setSortOrder(commonSort(row, column)[0]);
        setSortColumn(commonSort(row, column)[1]);
        let filteredItems = commonSort(row, column)[2];
        props.setRowsFunction(filteredItems);
    };

    //expand row
    const [openRow, setOpenRow] = useState(false);
    const [expandID, setExpandId] = useState("");
    const expandRow = (rowId) => {
        if (openRow && expandID !== rowId) {
            setExpandId(rowId);
            props.idSender(rowId);
        } else {
            setDeletedCheckItem(true);
            setOpenRow(!openRow);
            setExpandId(rowId);
            if (!openRow) {
                props.idSender(rowId);
            }
        }
    };

    const [isCheckItemPopup, setIsCheckItemPopup] = useState(false);

    const handleCheckItemAdd = (name, note) => {
        props.handleCheckItemAdd(name, note);
        setIsCheckItemPopup(false);
        setOpenRow(!openRow);
        setDisableButton(false);
    };

    const handleCheckItemCancel = () => {
        setIsCheckItemPopup(false);
    };

    const openCheckItemPopup = (id) => {
        props.openCheckItemPopup(id);
        setIsCheckItemPopup(true);
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`cig_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {t("Actions")}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`cig_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`cig_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => handleSort(props.rows, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const [noteDetails, setNoteDetails] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const showNoteDetails = (row) => {
        if (!editable) {
            setOpenDialog(true);
            setNoteDetails(row.note);
        }
    };

    return (
        <StyledTableDiv>
            <h1>
                {t("CheckItemGroup")} {t("List")}{" "}
            </h1>
            <AddButton onClick={() => addBlankRowHandler()} disabled={disableButton} />
            {props.pageLoaded === true ? (
                <React.Fragment>
                    <TextField id="cig_TextField_1" onChange={filterData} label={t("SearchCheckItemGroup")} variant="outlined" style={{ width: "40%" }} />
                </React.Fragment>
            ) : null}
            <Box m={2} />
            {props.rows.length > 0 ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    {renderTableCell([
                                        { id: "", label: "" },
                                        { id: "id", label: t("ID") },
                                        { id: "name", label: t("Name") },
                                        { id: "note", label: t("Note") },
                                        { id: "validityStartDate", label: t("StartDate") },
                                        { id: "validityEndDate", label: t("EndDate") },
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                                    <React.Fragment>
                                        <TableRow id={`cig_TableRow_1_${rowIndex}`} key={row.id}>
                                            <TableCell id={`cig_TableCell_1_expand`}>
                                                <IconButton id={`cig_IconButton_${rowIndex}`} aria-label="expand row" size="small" onClick={() => expandRow(row.id)}>
                                                    {openRow && expandID === row.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                            <TableCell id={`cig_TableCell_id`} align="center">
                                                {row.id}
                                            </TableCell>
                                            <TableCell id={`cig_TableCell_definition`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={"cig_name_TextField"}
                                                        error={errorStateName}
                                                        helperText={errorTextName}
                                                        onChange={NameHandler}
                                                        defaultValue={row.name}
                                                        variant="outlined"
                                                    />
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>
                                            <TableCell id={`cig_TableCell_note`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField id={"cig_note_TextField"} onChange={NoteHandler} defaultValue={row.note} variant="outlined" />
                                                ) : (
                                                    <>
                                                        {row.note.length >= 20 ? row.note.slice(0, 25) + "..." : row.note}
                                                        {row.note.length >= 20 ? <FcInfo onClick={() => showNoteDetails(row)} /> : null}
                                                    </>
                                                )}
                                            </TableCell>
                                            <TableCell id={`cig_TableCell_startDate`} align="center">
                                                {editable && (editableRow === row.id) & pickDate ? (
                                                    <FormControl id={`cig_FormControl_${rowIndex}`} pickDate={pickDate} variant="outlined">
                                                        <StartDate id={`cig_StartDatePicker_${rowIndex}`} HandleStartDate={onStartDateChangeHandler} startDate={startDate} size="small" />
                                                    </FormControl>
                                                ) : (
                                                    row.validityStartDate
                                                )}{" "}
                                            </TableCell>
                                            <TableCell id={`cig_TableCell_endDate`} align="center">
                                                {editable && (editableRow === row.id) & pickEndDate ? (
                                                    <FormControl id={`cig_FormControl_${rowIndex}`} pickEndDate={pickEndDate} variant="outlined">
                                                        <EndDate HandleEndDate={onEndDateChangeHandler} startDate={startDate} endDate={endDate} size="small" />
                                                    </FormControl>
                                                ) : (
                                                    row.validityEndDate
                                                )}{" "}
                                            </TableCell>
                                            <TableButtons
                                                table={"CheckItemGroup"}
                                                editable={editable}
                                                editableRow={editableRow}
                                                row={row}
                                                updateAddHandler={() => updateAddHandlerCIG(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                                openDetailPage={() => openCheckItemPopup(row.id)}
                                                detail={true}
                                                addDisabled={addButtonDisabled}
                                            />
                                        </TableRow>
                                        <TableRow>
                                            {expandID === row.id ? (
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                    <Collapse in={openRow} timeout="auto" unmountOnExit>
                                                        <Box margin={1}>
                                                            <Typography variant="h6" gutterBottom component="div">
                                                                {t("CheckItems")}
                                                            </Typography>
                                                            <Table size="small">
                                                                <TableHead>
                                                                    <TableRow id={`cig_TableRow_2_${rowIndex}`}>
                                                                        {renderTableCell(
                                                                            [
                                                                                { id: "name", label: t("Name") },
                                                                                { id: "note", label: t("Note") },
                                                                                { id: "actions", label: t("Actions") },
                                                                                { id: "doc", label: t("Documents")}
                                                                            ],
                                                                            false
                                                                        )}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {props.items.map((detailRow, itemIndex) => (
                                                                        <TableRow id={`cig_TableRow_3_${rowIndex}_${itemIndex}`} key={detailRow.id}>
                                                                            <TableCell id={`cig_TableCell_subName`} align="center">
                                                                                {detailRow.name}
                                                                            </TableCell>
                                                                            <TableCell id={`cig_TableCell_subNote`} align="center">
                                                                                {detailRow.note}
                                                                            </TableCell>
                                                                            <TableButtons
                                                                                editable={editableCI}
                                                                                editableRow={editableRowCI}
                                                                                row={detailRow}
                                                                                deleteCheckItem={deleteCheckItem}
                                                                                deleteHandlerCheckItem={() => deleteHandlerCheckItem(detailRow)}
                                                                            />
                                                                            <TableCell id={`eq_TableCell_14_${itemIndex}`} align="center" style={{width: "20%"}}>
                                                                                <Grid container >
                                                                                    <Grid item xs={12}>
                                                                                        <Tooltip title={t("UploadFile")}>
                                                                                            <IconButton id={`eq_TableCell_IconButton_${itemIndex}`} onClick={() => props.HandleFileUploaderPopupOpen(detailRow.id)}>
                                                                                                <CloudUpload />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Tooltip title={t("ShowFiles")}>
                                                                                            <IconButton id={`eq_TableCell_IconButton_1_${itemIndex}`} onClick={() =>props.HandleDocumentPopupOpen(detailRow.id)}>
                                                                                                <CloudDownload />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            ) : null}
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={props.rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="md_DialogDesc" style={{ overflow: "hidden", wordWrap: "break-word" }}>
                        {noteDetails}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => deleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={toggleModal} />
            {isCheckItemPopup ? <CheckItemPopup open={isCheckItemPopup} onAdd={handleCheckItemAdd} onCancel={handleCheckItemCancel} /> : null}
            {props.isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={props.isFileUploaderPopupOpen} onCancel={() => props.setIsFileUploaderPopupOpen(false)} onConfirm={props.UploadFiles} /> : null}
            {props.isDocumentPopupOpen === true ? (
                <DocumentPopup
                    id="eq_documentPopup"
                    isMaintenanceDocuments={false}
                    isEquipmentDocuments={true}
                    list={[]}
                    equipmentDocuments={props.checkItemFiles}
                    open={props.isDocumentPopupOpen}
                    deleteFile={null}
                    deleteEquipmentFiles={props.DeleteCheckItemFile}
                    close={() => props.setIsDocumentPopupOpen(false)}
                />
            ) : null}
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
